export default function formatDate(dateString) {
  // Parse the input date string
  const date = new Date(dateString);
  if (isNaN(date)) return "N/A"; // Return a default value for invalid dates

  // Get day, month, and year
  const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 to zero-based month
  const year = date.getFullYear();

  // Format the final string
  return `${day}/${month}/${year}`;
}
